const CHANGE_REPORT_CAR = 'CHANGE_REPORT_CAR'
const CLEAR_REPORT_CAR = 'CLEAR_REPORT_CAR'

const changeReportCarAction = data => {
  return {
    type: CHANGE_REPORT_CAR,
    data
  }
}

const changeReportCar = data => {
  return (dispatch) => {
    dispatch(changeReportCarAction(data))
  }
}

const clearReportCarAction = () => {
  return {
    type: CLEAR_REPORT_CAR
  }
}

const clearReportCar = () => {
  return (dispatch) => {
    dispatch(clearReportCarAction())
  }
}

export {
  changeReportCar,
  changeReportCarAction,
  CHANGE_REPORT_CAR,

  clearReportCar,
  clearReportCarAction,
  CLEAR_REPORT_CAR
}